// extracted by mini-css-extract-plugin
export default {"details":"LabOrderDetails_details__ZGzOf","notice":"LabOrderDetails_notice__dp-z0","noticeIcon":"LabOrderDetails_noticeIcon__NNdR-","noticeText":"LabOrderDetails_noticeText__Kte5Q"};